import { gql } from '@apollo/client';
import { BusinessUnitData } from './business-unit';

export const GET_ALL_BU = gql`
  query BusinessUnit_getAll {
    BusinessUnit_getAll {
      ${BusinessUnitData}
    }
  }
`;

export const GET_BU_BY_ID = gql`
  query BusinessUnit_findById($id: String!) {
    BusinessUnit_findById(id: $id) {
      ${BusinessUnitData}
    }
  }
`;

export const GET_BU_LIST = gql`
  query BusinessUnit_find($query: QueryBusinessUnitInput) {
    BusinessUnit_find(query: $query) {
      data {
        ${BusinessUnitData}
      }
      count
      page
      pages
      limit
    }
  }
`;

export const CREATE_BU = gql`
  mutation BusinessUnit_create($payload: CreateBusinessUnitInput!) {
    BusinessUnit_create(createBusinessUnitInput: $payload) {
      ${BusinessUnitData}
    }
  }
`;

export const UPDATE_BU = gql`
  mutation BusinessUnit_update($payload: UpdateBusinessUnitInput!) {
    BusinessUnit_update(updateBusinessUnitInput: $payload) {
      ${BusinessUnitData}
    }
  }
`;

export const DEACTIVATE_BU = gql`
  mutation BusinessUnit_deactivate($id: String!) {
    BusinessUnit_deactivate(id: $id) {
      ${BusinessUnitData}
    }
  }
`;

export const DELETE_BU = gql`
  mutation BusinessUnit_delete($id: String!) {
    BusinessUnit_delete(id: $id)
  }
`;

export * from './business-domain';
export * from './category';
export * from './product-group';
